<template>
    <div class="flex flex-col grow">
        <RouterView />
    </div>
</template>